module.exports = __webpack_public_path__ + "img/41.d41bbc2e.png";